module.exports = __webpack_public_path__ + "img/dd.b8de3666.png";